import useFormatPrice from '../../Hooks/use-format-price';
import { Row } from '../../SubComponents/Modals';
import { Text } from '../../SubComponents/Text';
import useTypeSafeLocalize from '../../Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from '../../localizations/types';
import { DockingLocationType } from '../flexible-routing';

interface FlexibleRoutingSummaryProps {
  pickupLocation?: DockingLocationType;
  dropoffLocation?: DockingLocationType;
  pickupPrice: number | undefined;
  dropoffPrice: number | undefined;
  textColor?: string;
}

const FlexibleRoutingSummary = (props: FlexibleRoutingSummaryProps) => {
  const formatPrice = useFormatPrice();
  const localize = useTypeSafeLocalize();

  return (
    <Row justifyContent="space-between" mb="3">
      <Row style={{ gap: '4px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke={props.textColor ? props.textColor : '#fff'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-map-pin"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            <Text color={props.textColor ? props.textColor : '#fff'}>
              {localize(LocalizationCategory.product, ProductLocalization.pickupLocation)}
              :
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke={props.textColor ? props.textColor : '#fff'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-map-pin"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            <Text color={props.textColor ? props.textColor : '#fff'}>
              {localize(
                LocalizationCategory.product,
                ProductLocalization.dropoffLocation
              )}
              :
            </Text>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'flex-start',
          }}
        >
          <Text color={props.textColor ? props.textColor : '#fff'}>
            {props.pickupLocation?.name}
          </Text>
          <Text color={props.textColor ? props.textColor : '#fff'}>
            {props.dropoffLocation?.name}
          </Text>
        </div>
      </Row>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'flex-end',
        }}
      >
        <Text color={props.textColor ? props.textColor : '#fff'}>
          {props.pickupPrice || props.pickupPrice === 0
            ? formatPrice(props.pickupPrice)
            : '-'}
        </Text>
        <Text color={props.textColor ? props.textColor : '#fff'}>
          {props.dropoffPrice || props.dropoffPrice === 0
            ? formatPrice(props.dropoffPrice)
            : '-'}
        </Text>
      </div>
    </Row>
  );
};

export default FlexibleRoutingSummary;
